import React, { useState, useEffect } from 'react'
import {
  Panel,
  Form,
  Button,
  Message,
  Checkbox,
  Row,
  Col,
  ButtonToolbar,
  Modal,
  ControlLabel,
  Input,
  Cascader,
  CheckboxGroup,
  SelectPicker,
  Uploader,
  Icon,
  ButtonGroup,
  IconButton,
} from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../../utils/loading'
import InputForm from '../../../components/forms/input/InputForm'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import { useParams, useHistory } from 'react-router-dom'
import {
  updateWithdrawRequest,
  downloadWithdrawPaymentFile,
  getDownloadFileByPath,
  getVenderRequestForm,
  getRmsLocationDatas,
  saveRequestVendor,
  saveRequestVendorFile,
  downRequestVendorFile,
  deleteRequestVendorFile,
} from '../../../redux/actions/withdrawRequest'
import pathname from '../../../constants/pathname'
import PdfRenderWidgets from '../../pdfWidgets/PdfRenderWidgets'
import KycMessage from '../../../components/message/kycMessage/KycMessage'
import { cloneDeep, isEmpty } from 'lodash-es'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import { isImageOrPdf, isRequired, isValidators } from '../../../utils/ValidatorUtils'
import classNames from 'classnames'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import { set } from 'nprogress'
import notification from '../../../utils/notification'
import { DELETE_SUCCESS_MSG, SAVE_FAILED_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import { downloadFile, previewFile } from '../../../utils/fileUtil'
import { v4 as uuidv4 } from 'uuid'

export default function WithdrawRequestWidget({ schema: _schema, ...props }) {
  const {
    showCommandButton,
    isEditAll,
    expenditureReport,
    certificationCPA,
    hidePreview,
    bankAccount,
    isFinalWithdraw,
    withdrawFile,
    isValidateEFormFile,
    eFormHeader,
    informational,
    statusConfirmActualResult,
    overBudgetMessage,
    handleGotoEformFile = () => {},
    isHasOverBudgetFile,
  } = props
  const [section, setSection] = useState()
  const [isEdit, setIsEdit] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [request, setRequest] = useState()
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [requestId, setRequestId] = useState('')
  const [isPdfError, setIsPdfError] = useState(false)
  const [previewPdf, setPreviewPdf] = useState()
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [noBankAccount, setNoBankAccount] = useState(false)
  const [withdrawAndClosure, setWithdrawAndClosure] = useState(false)

  const formVenderChange = useForm()
  const {
    register: register2,
    handleSubmit: handleSubmit2,
    errors: errors2,
    control: control2,
    setValue: setValue2,
    clearErrors: clearErrors2,
    setError: setError2,
  } = formVenderChange

  const formVenderChangeFile = useForm()
  const {
    register: register3,
    handleSubmit: handleSubmit3,
    errors: errors3,
    control: control3,
    setValue: setValue3,
    clearErrors: clearErrors3,
  } = formVenderChangeFile

  const [vendorRequestSchema, setVendorRequestSchema] = useState()
  const [vendorRequestShowModal, setVendorRequestShowModal] = useState()
  const [rmsLocation, setRmsLocation] = useState()
  const [editTypeVal, setEditTypeVal] = useState()
  const [fileLists, setFileLists] = useState([])
  const [fileList2, setFileList2] = useState([])
  const [fileTypeError, setFileTypeError] = useState(false)
  const [filesImage, setFilesImage] = useState([])
  const [delFilesImage, setDelFilesImage] = useState([])

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const requestIds = sessionStorage.getItem('param')?.substring(1)
  const history = useHistory()
  const defaultMaxFileSize = 5

  useEffect(() => {
    setIsEdit(isEditAll)
  }, [isEditAll])

  // useEffect(() => {
  //   if (bankAccount) {
  //     //check need to have all bankInfo
  //     if (!bankAccount.bankName) {
  //       setNoBankAccount(true)
  //     } else if (!bankAccount.bankAccountName) {
  //       setNoBankAccount(true)
  //     } else if (!bankAccount.bankAccountNumber) {
  //       setNoBankAccount(true)
  //     }
  //   }
  // }, [bankAccount])

  useEffect(() => {
    // let requestId = location.search.substring(1)
    let requestId = sessionStorage.getItem('param')?.substring(1)
    // console.log('WithdrawRequestWidget', 'request_id: ', requestId)
    if (requestId) {
      setRequestId(requestId)
      //off first load pdf
      //!hidePreview && handleGetDownloadWithdrawPaymentFile(requestId)
    }
  }, [location.search])

  useEffect(() => {
    if (projectId && requestIds) {
      handleGetVendorRequestSchema(projectId, requestIds)
    }
  }, [projectId, requestIds])

  const handleGetVendorRequestSchema = async (projectId, requestId) => {
    try {
      const resp = await getVenderRequestForm(projectId, requestId)

      if (resp) {
        setVendorRequestSchema(resp)
        setEditTypeVal(resp?.forms?.inputForm?.editType?.value)

        let newArr = []
        if (resp?.forms?.attachFiles?.values?.length > 0) {
          // console.log('resp vendorRequestSchema in if')
          resp?.forms?.attachFiles?.values.map((item) => {
            newArr.push({
              id: item.id,
              vid: uuidv4(),
              documentType: item.type || '',
              documentTypeDesc: item.type || '',
              fileName: item.label || '',
              attachfile: item.path || null,
            })
          })

          setFilesImage(newArr)
        }
      }
    } catch (e) {
      console.log('error handleGetVendorRequestSchema ', e)
    }
  }

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    var response
    try {
      console.log('call update.')
      response = await updateWithdrawRequest(projectId, requestId, request)

      // console.log('response', response)

      if (response) {
        setIsLoading(false)
        doneLoading()
        setIsError(false)
        setIsShowConfirm(false)

        if (withdrawAndClosure) {
          return history.push(`${pathname.proposal.closeOfProject}`)
        } else {
          return history.push(`${pathname.proposal.overview.overviewCoworker}`)
        }
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e.response.data)
      if (e?.response?.data?.errorMessage) {
        setIsError(e.response.data.errorMessage)
      } else {
        let errorMessage = ''
        e?.response?.data?.errors?.message?.forEach((element) => {
          errorMessage = errorMessage.concat(element)
        })
        setIsError(errorMessage)
      }
    }
    setIsLoading(false)
    doneLoading()
    setIsShowConfirm(false)
  }

  const onSubmit = (data) => {
    console.log('onSubmit data', data)
    console.log('withdrawAndClosure', withdrawAndClosure)

    let request = { ...data }
    setRequest(request)

    let isValidateExpendFile = true
    let isValidateCPAFile = true
    // console.log('expenditureReport = ', expenditureReport)
    // console.log('certificationCPA = ', certificationCPA)
    if (expenditureReport && expenditureReport.isRequired) {
      if (expenditureReport?.attachFiles?.value?.length > 0) {
        isValidateExpendFile = true
      } else {
        isValidateExpendFile = false
        setIsError('กรุณาแนบไฟล์ ' + expenditureReport.header)
        return
      }
    }

    if (certificationCPA) {
      if (certificationCPA?.attachFiles?.value?.length > 0) {
        isValidateCPAFile = true
      } else {
        isValidateCPAFile = false
        setIsError('กรุณาแนบไฟล์ ' + certificationCPA.header)
        return
      }
    }

    if (!isValidateEFormFile) {
      setIsError('กรุณาแนบไฟล์ ' + eFormHeader)
      return
    }

    if (isValidateExpendFile && isValidateCPAFile) {
      setIsShowConfirm(true)
      setIsError(false)
    }

    //setIsShowConfirm(true)
  }

  const onConfirm = () => {
    console.log('onConfirm', request)

    handleCallService(request)
    //setIsShowConfirm(false)
  }

  const onCancle = () => {
    console.log('onCancle')

    setRequest()
    setIsShowConfirm(false)
  }

  const handleGetDownloadWithdrawPaymentFile = async (requestId) => {
    startLoading()
    setIsLoading(true)
    setIsPdfError(false)
    setIsLoadingPDF(true)
    try {
      const response = await downloadWithdrawPaymentFile(projectId, requestId)
      // console.log('response preview pdf', response)
      if (response) {
        setPreviewPdf(response)
        setIsPdfError(false)
      } else {
        setIsPdfError(true)
      }
    } catch (e) {
      setIsPdfError(true)
    }
    setIsLoading(false)
    setIsLoadingPDF(false)
    doneLoading()
  }

  const handleGetDownloadWithdrawPaymentFileByPath = async (pathFile) => {
    startLoading()
    setIsLoading(true)
    setIsPdfError(false)
    setIsLoadingPDF(true)
    try {
      const response = await getDownloadFileByPath(pathFile)
      if (response) {
        setPreviewPdf(response)
        setIsPdfError(false)
      } else {
        setIsPdfError(true)
      }
    } catch (e) {
      setIsPdfError(true)
    }
    setIsLoading(false)
    setIsLoadingPDF(false)
    doneLoading()
  }

  const handleOpenModalVendorRequest = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const resp = await getRmsLocationDatas()
      // console.log('resp handleOpenModalVendorRequest', resp)
      console.log('vendorRequestSchema => ', vendorRequestSchema)
      if (resp.success) {
        setRmsLocation(resp.model)
        setVendorRequestShowModal(true)
      }
    } catch (e) {
      console.log('error handleOpenModalVendorRequest ', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmitVendorRequest = async (data) => {
    // console.log('onSubmitVendorRequest', data)
    // console.log('fileImage => ', filesImage.length)
    // console.log('fileImage => ', fileList2)
    // console.log('editTypeVal => ', editTypeVal)

    if (!editTypeVal || editTypeVal.length == 0) {
      // console.log('error editTypeVal ')
      let msg = vendorRequestSchema?.forms?.inputForm?.editType.validators?.find(
        (item) => item.type === 'REQUIRED'
      )

      setError2(vendorRequestSchema?.forms?.inputForm.editType.name, {
        type: 'manual',
        message: msg.errorMessage || 'กรุณาเลือกการทำรายการ',
      })

      return false
    }

    if (filesImage.length == 0) {
      notification.open('error', {
        title: 'กรุณาแนบเอกสารประกอบ',
        duration: 5000,
      })
      return false
    }

    // return false

    setIsLoading(true)
    startLoading()
    try {
      const formData = new FormData()
      formData.append('Id', vendorRequestSchema?.forms?.inputForm?.id || '')
      formData.append('StatusCode', 0)
      formData.append('EditType', editTypeVal ? editTypeVal.join(',') : '')
      formData.append('VatRegistration', data.vatRegistration || '')
      formData.append('Building', data.building || '')
      formData.append('FloorRoom', data.floorRoom || '')
      formData.append('AddressNumber', data.addressNumber || '')
      formData.append('Moo', data.moo || '')
      formData.append('Soi', data.soi || '')
      formData.append('Village', data.village || '')
      formData.append('Road', data.road || '')
      formData.append('Location', data.location || '')
      formData.append('EncpTaxId', vendorRequestSchema?.forms?.rmsMessageInfo?.encpTaxId || '')
      formData.append('VendorCode', vendorRequestSchema?.forms?.rmsMessageInfo?.vendorCode || '')
      formData.append('WithholdingTaxType', data.withholdingTaxType)

      let c = 0
      filesImage &&
        filesImage?.forEach((element) => {
          console.log('element => ', element)
          if (element.id === null) {
            formData.append(`AttachFilesList[${c}].DocumentTypeId`, element.documentType)
            formData.append(`AttachFilesList[${c}].AttachFiles`, element.attachfile)

            c += 1
          }
        })

      fileList2 &&
        fileList2?.forEach((element) => {
          console.log('element => ', element)
          if (element.id === null) {
            formData.append(`AttachFilesList[${c}].DocumentTypeId`, element.documentType)
            formData.append(`AttachFilesList[${c}].AttachFiles`, element.attachfile)

            c += 1
          }
        })

      delFilesImage &&
        delFilesImage?.forEach((element) => {
          formData.append('DeleteFileIds', element)
        })

      const resp = await saveRequestVendor(projectId, requestId, formData, 'Save')
      console.log('resp => ', resp)

      if (resp) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })

        setValue3(vendorRequestSchema?.forms?.attachFiles.name, [])
        setValue3(vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.name, '')
        setFileList2([])

        // setVendorRequestSchema(resp)
        handleGetVendorRequestSchema(projectId, requestIds)
        setVendorRequestShowModal(false)
      } else {
        notification.open('error', {
          title: SAVE_FAILED_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error handleOpenModalVendorRequest ', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || SAVE_FAILED_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  // const onSubmitVendorRequestFile = async (data) => {
  //   console.log('onSubmitVendorRequestFile', data)

  //   const formData = new FormData()
  //   formData.append('DocumentTypeId', data?.documentType || '')

  //   data.attachfile &&
  //     data.attachfile?.forEach((element) => {
  //       formData.append('AttachFiles', element.blobFile)
  //     })

  //   handleVendorSaveFile(formData)
  // }
  const onSubmitVendorRequestFile = async (data) => {
    console.log('onSubmitVendorRequestFile', data)

    let documentTypeDesc =
      vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.options?.find(
        (item) => item.value === data.documentType
      )

    let newArr = cloneDeep(filesImage || [])

    newArr.push({
      id: null,
      vid: uuidv4(),
      documentType: data.documentType,
      documentTypeDesc: documentTypeDesc.label || '',
      fileName: data.attachfile[0]?.name || '',
      attachfile: data.attachfile[0]?.blobFile || null,
    })

    setValue3(vendorRequestSchema?.forms?.attachFiles.name, [])
    setValue3(vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.name, '')
    setFileList2([])

    setFilesImage(newArr)
  }

  const handleVendorSaveFile = async (request) => {
    startLoading()
    setIsLoading(true)

    try {
      let response = await saveRequestVendorFile(request, projectId, requestIds)
      console.log('resssss => ', response)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })

        setValue3(vendorRequestSchema?.forms?.attachFiles.name, [])
        setValue3(vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.name, '')
        setFileList2([])

        handleGetVendorRequestSchema(projectId, requestIds)
      } else {
        notification.open('error', {
          title: SAVE_FAILED_MSG,
          duration: 5000,
        })
      }
    } catch (error) {
      console.log('error', error)
      notification.open('error', {
        title: SAVE_FAILED_MSG,
        duration: 5000,
      })
    }

    setIsLoading(false)
    doneLoading()
  }

  // const handlePreviewFile = async (fileObj) => {
  //   console.log('file => ', fileObj)

  //   startLoading()
  //   setIsLoading(true)
  //   try {
  //     var file = await downRequestVendorFile(fileObj?.id)
  //     var fileName = fileObj?.name || fileObj?.id

  //     previewFile(file, fileName)
  //   } catch (e) {
  //     console.log(e)
  //     notification.open('error', {
  //       title: 'แสดง ไม่สำเร็จ ',
  //       duration: 5000,
  //     })
  //   }
  //   doneLoading()
  //   setIsLoading(false)
  // }

  const handlePreviewFile = async (fileObj) => {
    console.log('file => ', fileObj)

    // return false

    startLoading()
    setIsLoading(true)

    try {
      if (fileObj.id === null) {
        previewFile(fileObj.attachfile, fileObj.fileName)
      } else {
        var file = await downRequestVendorFile(fileObj?.id)
        var fileName = fileObj?.name || fileObj?.id

        previewFile(file, fileName)
      }
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'แสดง ไม่สำเร็จ ',
        duration: 5000,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleDownloadFile = async (fileObj) => {
    console.log('file => ', fileObj)

    setIsLoading(true)
    startLoading()

    try {
      if (fileObj.id === null) {
        downloadFile(fileObj.attachfile, fileObj.fileName)
      } else {
        var file = await downRequestVendorFile(fileObj.id)
        var fileName = fileObj.label

        downloadFile(file, fileName)
      }
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleDeleteFile = async (fileObj) => {
    console.log('handleDeleteFile => ', fileObj)

    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      let oldFiles = cloneDeep(filesImage || [])

      let newArr = []
      if (oldFiles && oldFiles.length > 0) {
        oldFiles.map((item) => {
          if (item.vid !== fileObj.vid) {
            newArr.push(item)
          }
        })
        setFilesImage(newArr)

        if (fileObj.id !== null) {
          let delArr = cloneDeep(delFilesImage || [])
          delArr.push(fileObj.id)
          setDelFilesImage(delArr)
        }
      }

      // let response = await deleteRequestVendorFile(projectId, requestIds, fileObj.id)
      // console.log('resssss => ', response)
      // if (response) {
      //   notification.open('success', {
      //     title: DELETE_SUCCESS_MSG,
      //   })

      //   if (response?.forms?.attachFiles?.values?.length > 0) {
      //     // console.log('resp vendorRequestSchema in if')
      //     let newArr = []
      //     response?.forms?.attachFiles?.values.map((item) => {
      //       newArr.push({
      //         id: item.id,
      //         vid: uuidv4(),
      //         documentType: item.type || '',
      //         documentTypeDesc: item.type || '',
      //         fileName: item.label || '',
      //         attachfile: item.path || null,
      //       })
      //     })

      //     setFilesImage(newArr)
      //   } else {
      //     setFilesImage([])
      //   }

      //   setVendorRequestSchema(response)
      // } else {
      //   notification.open('error', {
      //     title: 'ลบไม่สำเร็จ',
      //   })
      // }
    } catch (error) {
      console.log('error', error)
      notification.open('error', {
        title: 'ลบไม่สำเร็จ',
      })
    }

    setIsLoading(false)
    doneLoading()
  }

  const handleSendRequestEditVendorRequest = async (data) => {
    console.log('handleSendRequestEditVendorRequest', data)

    // console.log('onSubmitVendorRequest', data)
    // console.log('fileImage => ', filesImage.length)
    // console.log('fileImage => ', fileList2)
    // console.log('editTypeVal => ', editTypeVal)

    if (!editTypeVal || editTypeVal.length == 0) {
      // console.log('error editTypeVal ')
      let msg = vendorRequestSchema?.forms?.inputForm?.editType.validators?.find(
        (item) => item.type === 'REQUIRED'
      )

      setError2(vendorRequestSchema?.forms?.inputForm.editType.name, {
        type: 'manual',
        message: msg.errorMessage || 'กรุณาเลือกการทำรายการ',
      })

      return false
    }

    if (filesImage.length == 0) {
      notification.open('error', {
        title: 'กรุณาแนบเอกสารประกอบ',
        duration: 5000,
      })
      return false
    }

    // return false

    setIsLoading(true)
    startLoading()
    try {
      const formData = new FormData()
      formData.append('Id', vendorRequestSchema?.forms?.inputForm?.id || '')
      formData.append('StatusCode', 0)
      formData.append('EditType', editTypeVal ? editTypeVal.join(',') : '')
      formData.append('VatRegistration', data.vatRegistration || '')
      formData.append('Building', data.building || '')
      formData.append('FloorRoom', data.floorRoom || '')
      formData.append('AddressNumber', data.addressNumber || '')
      formData.append('Moo', data.moo || '')
      formData.append('Soi', data.soi || '')
      formData.append('Village', data.village || '')
      formData.append('Road', data.road || '')
      formData.append('Location', data.location || '')
      formData.append('EncpTaxId', vendorRequestSchema?.forms?.rmsMessageInfo?.encpTaxId || '')
      formData.append('VendorCode', vendorRequestSchema?.forms?.rmsMessageInfo?.vendorCode || '')
      formData.append('WithholdingTaxType', data.withholdingTaxType)

      let c = 0
      filesImage &&
        filesImage?.forEach((element) => {
          console.log('element => ', element)
          if (element.id === null) {
            formData.append(`AttachFilesList[${c}].DocumentTypeId`, element.documentType)
            formData.append(`AttachFilesList[${c}].AttachFiles`, element.attachfile)

            c += 1
          }
        })

      delFilesImage &&
        delFilesImage?.forEach((element) => {
          formData.append('DeleteFileIds', element)
        })

      const resp = await saveRequestVendor(projectId, requestId, formData, 'SendRequest')

      console.log('resp => ', resp)

      if (resp.status == 200) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        // setVendorRequestSchema(resp)
        handleGetVendorRequestSchema(projectId, requestIds)
        setVendorRequestShowModal(false)
      } else {
        notification.open('error', {
          title: resp.message || SAVE_FAILED_MSG,
          duration: 5000,
        })
        handleGetVendorRequestSchema(projectId, requestIds)
      }
    } catch (e) {
      console.log('error handleOpenModalVendorRequest ', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || SAVE_FAILED_MSG,
        duration: 5000,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const msgConfirmActualResult = () => {
    if (statusConfirmActualResult?.confMessage?.length <= 0) {
      return ''
    }

    let itemStr = 'กรุณายืนยันผลการดำเนินการจริง <br /> <br />'

    statusConfirmActualResult?.confMessage?.map((item, index) => {
      itemStr += `${index + 1})  ${item} <br />`
    })

    return (
      <Row style={{ marginBottom: 20, marginLeft: 10, marginTop: 20 }}>
        <Message
          // key={index}
          showIcon
          type="error"
          description={<div dangerouslySetInnerHTML={{ __html: itemStr || '' }} />}
          style={{ marginBottom: 10 }}
        />
      </Row>
    )
  }

  return formSchema ? (
    <Panel
      shaded
      header={formSchema.header}
      eventKey={2}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      {isLoading && <OverlayLoader />}

      {!hidePreview && (
        <div>
          {isPdfError ? (
            <Message showIcon type="error" description={'ไม่พบไฟล์ PDF'} />
          ) : (
            <PdfRenderWidgets
              file={previewPdf}
              isLoading={isLoadingPDF}
              fileName={'แบบขอเบิกเงินโครงการ'}
              header={'แบบขอเบิกเงินโครงการ'}
              loadingMessage={'กรุณารอสักครู่ ระบบกำลังสร้าง PDF แบบขอเบิกเงินโครงการ...'}
              onReload={() => {
                handleGetDownloadWithdrawPaymentFile(requestId)
              }}
              firstExpandToReload={true}
            />
          )}
        </div>
      )}

      {formSchema.note && (
        <InputForm
          schema={formSchema.note}
          informational={vendorRequestSchema?.forms?.rmsMessageInfo?.messageInfo || null}
          rows={3}
          componentClass="textarea"
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
        />
      )}

      {isFinalWithdraw && (
        <Checkbox
          checked={withdrawAndClosure}
          onChange={(_, checked) => setWithdrawAndClosure(checked)}
        >
          {'เบิกพร้อมขอปิด'}
        </Checkbox>
      )}

      {isError && <Message showIcon type="error" description={isError} />}

      {/* {noBankAccount && (
        <Message
          showIcon
          type="error"
          description={'ข้อมูลบัญชีธนาคารไม่ครบถ้วน ไม่สามารถขอเบิกงวดเงินได้'}
        />
      )} */}

      {/* <Row style={{ marginBottom: 20, marginLeft: 10, marginTop: 20 }}> */}
      {/* <p>ขอความอนุเคราะห์ทำแบบประเมินความพึงพอใจผู้ใช้งานระบบบริหารโครงการ (e-Granting)</p>
        <p tyle={{ marginTop: 10 }}>
          <a href="https://forms.gle/JAPanGNysDM35jjj7" target="_blank">
            คลิกเพื่อทำแบบประเมิน
          </a>
        </p>

        <Message
          style={{ marginTop: 10 }}
          showIcon={false}
          type="info"
          title="คำชี้แจง:"
          description={
            'แบบสอบถามชุดนี้จัดทำขึ้นเพื่อประเมินความพึงพอใจ/ไม่พึงพอใจ ความต้องการและความคาดหวังของผู้ใช้งานระบบ ต่อการใช้งานระบบ'
          }
        /> */}

      {formSchema.verifyKyc && (
        <Row style={{ marginBottom: 20, marginLeft: 10, marginTop: 20 }}>
          <KycMessage schema={formSchema.verifyKyc} />
        </Row>
      )}

      {!statusConfirmActualResult?.confStatus && msgConfirmActualResult()}

      
      {formSchema?.issueMessage &&
        formSchema?.issueMessage.map((item, index) => (
          <Message
            showIcon
            key={`issue-message-${index}`}
            type="warning"
            description={<div dangerouslySetInnerHTML={{ __html: item }} />}
            style={{ marginBottom: 10 }}
          />
      ))}

      {console.log('isHasOverBudgetFile', isHasOverBudgetFile)}
      {console.log('overBudgetMessage', overBudgetMessage)}
      
      {isHasOverBudgetFile ? 
        <Message
            showIcon
            type="success"
            description={<span>{isHasOverBudgetFile}</span>}
            style={{ marginBottom: 10 }}
          />
        :
        overBudgetMessage && 
          <Message
            showIcon
            type="error"
            description={<span>{overBudgetMessage} <a onClick={handleGotoEformFile}>ไปแนบไฟล์</a></span>}
            style={{ marginBottom: 10 }}
          />
      }

      <hr />
      {vendorRequestSchema?.messageProceed && (
        <Message
          type="warning"
          description={
            <div dangerouslySetInnerHTML={{ __html: vendorRequestSchema?.messageProceed }} />
          }
          style={{ marginBottom: 10 }}
        />
      )}

      <ButtonToolbar>
        <Button
          // ripple
          // appearance="ghost"
          color="rgb(45, 168, 136)"
          appearance="primary"
          onClick={handleSubmit(onSubmit)}
          disabled={
            !!formSchema.verifyKyc ||
            !statusConfirmActualResult?.confStatus ||
            vendorRequestSchema?.buttonWithdrawStatus
          }
        >
          {formSchema.buttonText}
        </Button>

        {vendorRequestSchema?.forms?.buttons?.buttonMain && (
          <Button
            // ripple
            // appearance="ghost"
            color="blue"
            // appearance="primary"
            // onClick={handleSubmit(onSubmit)}
            onClick={() => {
              handleOpenModalVendorRequest()
            }}
            disabled={vendorRequestSchema?.forms?.buttons?.buttonMainDisabled}
          >
            {vendorRequestSchema?.forms?.buttons?.buttonMain}
          </Button>
        )}
      </ButtonToolbar>

      <Modal
        size={'lg'}
        show={vendorRequestShowModal}
        onHide={() => setVendorRequestShowModal(false)}
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>{vendorRequestSchema?.header || ''}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ marginLeft: 20, marginRight: 20, minHeight: 400 }}>
            <Panel expanded collapsible bordered>
              <div>
                {vendorRequestSchema?.forms?.inputForm.editType && (
                  <Row>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      {/* {!editTypeVal?.find((item) => item === '0' || item === '1') && (
                        <Message
                          type="error"
                          description={
                            vendorRequestSchema?.forms?.inputForm.editType?.validators.find(
                              (item) => item.type === 'REQUIRED'
                            )?.errorMessage || ''
                          }
                        />
                      )} */}

                      <ErrorMessage error={errors2.editType} />
                      <Controller
                        name={vendorRequestSchema?.forms?.inputForm.editType.name}
                        control={control2}
                        defaultValue={vendorRequestSchema?.forms?.inputForm.editType.value}
                        rules={isValidators(
                          vendorRequestSchema?.forms?.inputForm?.editType.validators
                        )}
                        render={(props) => {
                          return (
                            <CheckboxGroup
                              inline
                              name={vendorRequestSchema?.forms?.inputForm.editType.name}
                              value={editTypeVal || []}
                              onChange={(value) => {
                                console.log(value)
                                setEditTypeVal(value)
                                props.onChange(value)
                                // if (value.length === 0) {
                                //   let newArr = []
                                //   vendorRequestSchema?.forms?.inputForm.editType.options.map(
                                //     (item, index) => {
                                //       newArr.push(item.value)
                                //     }
                                //   )
                                //   setEditTypeVal(newArr)
                                // }
                              }}
                            >
                              {vendorRequestSchema?.forms?.inputForm.editType.options.map(
                                (item, index) => {
                                  return (
                                    <Checkbox key={index} value={item.value}>
                                      {item.label}
                                    </Checkbox>
                                  )
                                }
                              )}
                            </CheckboxGroup>
                          )
                        }}
                      />
                    </Col>
                  </Row>
                )}
              </div>

              {editTypeVal?.find((item) => item === '2') && (
                <div>
                  <Row style={{ marginTop: 20 }}>
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <ControlLabel
                        className={classNames(
                          isRequired(
                            vendorRequestSchema?.forms?.inputForm.withholdingTaxType?.validators
                          ) && 'required'
                        )}
                      >
                        {vendorRequestSchema?.forms?.inputForm.withholdingTaxType.label}
                      </ControlLabel>
                      <ErrorMessage error={errors2.withholdingTaxType} />
                      <Controller
                        name={vendorRequestSchema?.forms?.inputForm.withholdingTaxType.name}
                        control={control2}
                        defaultValue={
                          vendorRequestSchema?.forms?.inputForm.withholdingTaxType.value
                        }
                        rules={isValidators(
                          vendorRequestSchema?.forms?.inputForm?.withholdingTaxType.validators
                        )}
                        render={(props) => {
                          return (
                            <SelectPicker
                              searchable={false}
                              data={
                                vendorRequestSchema?.forms?.inputForm?.withholdingTaxType
                                  ?.options || []
                              }
                              // disabled={disabledValue.fromBudgetYear}
                              value={props.value}
                              block
                              onChange={(value) => {
                                props.onChange(value)
                                // handleChangeBudgetYear(schema.budgetYearEndOption.name, value)
                              }}
                            />
                          )
                        }}
                      />
                    </Col>
                  </Row>
                  {/* <Row style={{ marginTop: 20 }}>
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <ControlLabel
                        className={classNames(
                          isRequired(
                            vendorRequestSchema?.forms?.inputForm.withholdingTaxType?.validators
                          ) && 'required'
                        )}
                      >
                        {vendorRequestSchema?.forms?.inputForm?.withholdingTaxType?.label}
                      </ControlLabel>
                      <ErrorMessage error={errors2.withholdingTaxType} />
                      <Controller
                        name={vendorRequestSchema?.forms?.inputForm.withholdingTaxType.name}
                        control={control2}
                        defaultValue={
                          vendorRequestSchema?.forms?.inputForm.withholdingTaxType.value
                        }
                        rules={isValidators(
                          vendorRequestSchema?.forms?.inputForm?.withholdingTaxType.validators
                        )}
                        render={(props) => {
                          return (
                            <SelectPicker
                              searchable={false}
                              data={
                                vendorRequestSchema?.forms?.inputForm?.vatRegistration?.options ||
                                []
                              }
                              // disabled={disabledValue.fromBudgetYear}
                              value={props.value}
                              block
                              onChange={(value) => {
                                props.onChange(value)
                                // handleChangeBudgetYear(schema.budgetYearEndOption.name, value)
                              }}
                            />
                          )
                        }}
                      />
                    </Col>
                  </Row> */}
                </div>
              )}

              {editTypeVal?.find((item) => item === '0') && (
                <div>
                  <Row style={{ marginTop: 20 }}>
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <ControlLabel
                        className={classNames(
                          isRequired(
                            vendorRequestSchema?.forms?.inputForm.vatRegistration?.validators
                          ) && 'required'
                        )}
                      >
                        {vendorRequestSchema?.forms?.inputForm.vatRegistration.label}
                      </ControlLabel>
                      <ErrorMessage error={errors2.vatRegistration} />
                      <Controller
                        name={vendorRequestSchema?.forms?.inputForm.vatRegistration.name}
                        control={control2}
                        defaultValue={vendorRequestSchema?.forms?.inputForm.vatRegistration.value}
                        rules={isValidators(
                          vendorRequestSchema?.forms?.inputForm?.vatRegistration.validators
                        )}
                        render={(props) => {
                          return (
                            <SelectPicker
                              searchable={false}
                              data={
                                vendorRequestSchema?.forms?.inputForm?.vatRegistration?.options ||
                                []
                              }
                              // disabled={disabledValue.fromBudgetYear}
                              value={props.value}
                              block
                              onChange={(value) => {
                                props.onChange(value)
                                // handleChangeBudgetYear(schema.budgetYearEndOption.name, value)
                              }}
                            />
                          )
                        }}
                      />
                    </Col>
                  </Row>
                </div>
              )}

              {editTypeVal?.find((item) => item === '1') && (
                <div>
                  <Row style={{ marginTop: 20 }}>
                    {vendorRequestSchema?.forms?.inputForm.building && (
                      <Col xs={24} sm={24} md={18} lg={18}>
                        <ControlLabel
                          className={classNames(
                            isRequired(
                              vendorRequestSchema?.forms?.inputForm.building?.validators
                            ) && 'required'
                          )}
                        >
                          {vendorRequestSchema?.forms?.inputForm.building.label}
                        </ControlLabel>
                        <ErrorMessage error={errors2.building} />
                        <Input
                          placeholder={vendorRequestSchema?.forms?.inputForm.building.label}
                          defaultValue={vendorRequestSchema?.forms?.inputForm.building.value}
                          name={vendorRequestSchema?.forms?.inputForm.building.name}
                          inputRef={register2(
                            isValidators(vendorRequestSchema?.forms?.inputForm.building.validators)
                          )}
                        />
                      </Col>
                    )}

                    {vendorRequestSchema?.forms?.inputForm?.floorRoom && (
                      <Col xs={24} sm={24} md={6} lg={6}>
                        <ControlLabel
                          className={classNames(
                            isRequired(
                              vendorRequestSchema?.forms?.inputForm?.floorRoom.validators
                            ) && 'required'
                          )}
                        >
                          {vendorRequestSchema?.forms?.inputForm?.floorRoom.label}
                        </ControlLabel>
                        <ErrorMessage error={errors2.floorRoom} />
                        <Input
                          placeholder={vendorRequestSchema?.forms?.inputForm?.floorRoom.label}
                          defaultValue={vendorRequestSchema?.forms?.inputForm?.floorRoom.value}
                          name={vendorRequestSchema?.forms?.inputForm?.floorRoom.name}
                          inputRef={register2(
                            isValidators(
                              vendorRequestSchema?.forms?.inputForm?.floorRoom.validators
                            )
                          )}
                        />
                      </Col>
                    )}
                  </Row>

                  <Row style={{ marginTop: 10 }}>
                    {vendorRequestSchema?.forms?.inputForm?.addressNumber && (
                      <Col xs={24} sm={24} md={5} lg={5}>
                        <ControlLabel
                          className={classNames(
                            isRequired(
                              vendorRequestSchema?.forms?.inputForm?.addressNumber.validators
                            ) && 'required'
                          )}
                        >
                          {vendorRequestSchema?.forms?.inputForm?.addressNumber.label}
                        </ControlLabel>
                        <ErrorMessage error={errors2.addressNumber} />
                        <Input
                          placeholder={vendorRequestSchema?.forms?.inputForm?.addressNumber.label}
                          defaultValue={vendorRequestSchema?.forms?.inputForm?.addressNumber.value}
                          name={vendorRequestSchema?.forms?.inputForm?.addressNumber.name}
                          inputRef={register2(
                            isValidators(
                              vendorRequestSchema?.forms?.inputForm?.addressNumber.validators
                            )
                          )}
                        />
                      </Col>
                    )}

                    {vendorRequestSchema?.forms?.inputForm?.moo && (
                      <Col xs={24} sm={24} md={3} lg={3}>
                        <ControlLabel
                          className={classNames(
                            isRequired(vendorRequestSchema?.forms?.inputForm?.moo.validators) &&
                              'required'
                          )}
                        >
                          {vendorRequestSchema?.forms?.inputForm?.moo.label}
                        </ControlLabel>
                        <ErrorMessage error={errors2.moo} />
                        <Input
                          placeholder={vendorRequestSchema?.forms?.inputForm?.moo.label}
                          defaultValue={vendorRequestSchema?.forms?.inputForm?.moo.value}
                          name={vendorRequestSchema?.forms?.inputForm?.moo.name}
                          inputRef={register2(
                            isValidators(vendorRequestSchema?.forms?.inputForm?.moo.validators)
                          )}
                        />
                      </Col>
                    )}

                    {vendorRequestSchema?.forms?.inputForm?.soi && (
                      <Col xs={24} sm={24} md={8} lg={8}>
                        <ControlLabel
                          className={classNames(
                            isRequired(vendorRequestSchema?.forms?.inputForm?.soi.validators) &&
                              'required'
                          )}
                        >
                          {vendorRequestSchema?.forms?.inputForm?.soi.label}
                        </ControlLabel>
                        <ErrorMessage error={errors2.soi} />
                        <Input
                          placeholder={vendorRequestSchema?.forms?.inputForm?.soi.label}
                          defaultValue={vendorRequestSchema?.forms?.inputForm?.soi.value}
                          name={vendorRequestSchema?.forms?.inputForm?.soi.name}
                          inputRef={register2(
                            isValidators(vendorRequestSchema?.forms?.inputForm?.soi.validators)
                          )}
                        />
                      </Col>
                    )}

                    {vendorRequestSchema?.forms?.inputForm?.village && (
                      <Col xs={24} sm={24} md={8} lg={8}>
                        <ControlLabel
                          className={classNames(
                            isRequired(vendorRequestSchema?.forms?.inputForm?.village.validators) &&
                              'required'
                          )}
                        >
                          {vendorRequestSchema?.forms?.inputForm?.village.label}
                        </ControlLabel>
                        <ErrorMessage error={errors2.village} />
                        <Input
                          placeholder={vendorRequestSchema?.forms?.inputForm?.village.label}
                          defaultValue={vendorRequestSchema?.forms?.inputForm?.village.value}
                          name={vendorRequestSchema?.forms?.inputForm?.village.name}
                          inputRef={register2(
                            isValidators(vendorRequestSchema?.forms?.inputForm?.village.validators)
                          )}
                        />
                      </Col>
                    )}
                  </Row>

                  <Row style={{ marginTop: 10 }}>
                    {vendorRequestSchema?.forms?.inputForm?.road && (
                      <Col xs={24} sm={24} md={8} lg={8}>
                        <ControlLabel
                          className={classNames(
                            isRequired(vendorRequestSchema?.forms?.inputForm?.road.validators) &&
                              'required'
                          )}
                        >
                          {vendorRequestSchema?.forms?.inputForm?.road.label}
                        </ControlLabel>
                        <ErrorMessage error={errors2.road} />
                        <Input
                          placeholder={vendorRequestSchema?.forms?.inputForm?.road.label}
                          defaultValue={vendorRequestSchema?.forms?.inputForm?.road.value}
                          name={vendorRequestSchema?.forms?.inputForm?.road.name}
                          inputRef={register2(
                            isValidators(vendorRequestSchema?.forms?.inputForm?.road.validators)
                          )}
                        />
                      </Col>
                    )}

                    {vendorRequestSchema?.forms?.inputForm?.location && (
                      <Col xs={24} sm={24} md={16} lg={16}>
                        <ControlLabel
                          className={classNames(
                            isRequired(
                              vendorRequestSchema?.forms?.inputForm?.location.validators
                            ) && 'required'
                          )}
                        >
                          {vendorRequestSchema?.forms?.inputForm?.location.label}
                        </ControlLabel>
                        <ErrorMessage error={errors2.location} />
                        <Controller
                          name={vendorRequestSchema?.forms?.inputForm?.location.name}
                          control={control2}
                          defaultValue={vendorRequestSchema?.forms?.inputForm?.location.value}
                          rules={isValidators(
                            vendorRequestSchema?.forms?.inputForm?.location.validators
                          )}
                          render={(props) => {
                            return (
                              <Cascader
                                size="lg"
                                block
                                menuWidth={180}
                                data={rmsLocation || []}
                                value={props.value}
                                onChange={(value) => {
                                  props.onChange(value)
                                }}
                                placeholder={vendorRequestSchema?.forms?.inputForm?.location.label}
                                // disabled={isSameAddress}
                              ></Cascader>
                            )
                          }}
                        />
                      </Col>
                    )}
                  </Row>
                </div>
              )}

              {vendorRequestSchema?.forms?.attachFiles && (
                <Panel expanded collapsible bordered style={{ marginTop: 10 }}>
                  <div>
                    <Row style={{ marginTop: 20 }}>
                      <Col xs={24} sm={24} md={24} lg={24}>
                        <ControlLabel
                          className={classNames(
                            isRequired(vendorRequestSchema?.forms?.attachFiles.validators) &&
                              'required'
                          )}
                        >
                          {vendorRequestSchema?.forms?.attachFiles.header}
                        </ControlLabel>
                        <ErrorMessage
                          error={errors3[`${vendorRequestSchema?.forms?.attachFiles.name}`]}
                        />
                        <Controller
                          key={`${vendorRequestSchema?.forms?.attachFiles.name}`}
                          name={`${vendorRequestSchema?.forms?.attachFiles.name}`}
                          control={control3}
                          rules={isValidators(vendorRequestSchema?.forms?.attachFiles.validators)}
                          defaultValue={''}
                          render={(props) => {
                            return (
                              <>
                                <p
                                  style={{ fontSize: 'small', color: 'red' }}
                                >{`  *อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                                  vendorRequestSchema?.forms?.attachFiles.fileType ||
                                  '.jpg, .jpeg, .png'
                                } , ขนาดไฟล์ไม่เกิน ${
                                  vendorRequestSchema?.forms?.attachFiles.fileSize ||
                                  defaultMaxFileSize
                                } MB`}</p>
                                <Uploader
                                  accept={
                                    vendorRequestSchema?.forms?.attachFiles.fileType ||
                                    '.jpg, .jpeg, .png'
                                  }
                                  autoUpload={false}
                                  disabled={vendorRequestSchema?.forms?.attachFiles.disabled}
                                  fileListVisible={true}
                                  listType="picture-text"
                                  // fileList={props.value || []}
                                  fileList={fileList2 || []}
                                  multiple={false}
                                  onChange={(fileList) => {
                                    if (isEmpty(fileList)) {
                                      props.onChange(undefined)
                                      setFileList2([])
                                    } else {
                                      let file = fileList[fileList.length - 1]
                                      console.log('file upload', file)
                                      if (
                                        file?.blobFile?.size >
                                        (vendorRequestSchema?.forms?.attachFiles.fileSize ||
                                          defaultMaxFileSize) *
                                          1024 *
                                          1024
                                      ) {
                                        notification.open('error', {
                                          title: `ขนาดไฟล์เกิน ${
                                            vendorRequestSchema?.forms?.attachFiles.fileSize ||
                                            defaultMaxFileSize
                                          } MB`,
                                          duration: 5000,
                                        })
                                        return
                                      }

                                      if (isImageOrPdf(file.blobFile.type)) {
                                        let lastFile = [file]
                                        setFileList2(lastFile)
                                        // console.log('lastFile', lastFile)
                                        props.onChange(lastFile)
                                        setFileTypeError(false)

                                        // props.onChange(fileList)
                                        // setFileTypeError(false)
                                      } else {
                                        setFileTypeError(true)
                                        notification.open('error', {
                                          title:
                                            'ชนิดที่รองรับ ' +
                                              vendorRequestSchema?.forms?.attachFiles.fileType ||
                                            '.jpg, .jpeg, .png',
                                          duration: 5000,
                                        })
                                      }
                                    }
                                  }}
                                  draggable
                                  style={{ marginBottom: 10 }}
                                >
                                  <div>
                                    <Icon size="2x" icon="upload2" />
                                    <small className="uploder__text">{`   ${vendorRequestSchema?.forms?.attachFiles.description}`}</small>
                                  </div>
                                </Uploader>
                              </>
                            )
                          }}
                        />
                      </Col>
                      <Col xs={24} sm={24} md={16} lg={16}>
                        <ControlLabel
                          className={classNames(
                            isRequired(
                              vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.validators
                            ) && 'required'
                          )}
                        >
                          {vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.label}
                        </ControlLabel>
                        {/* <ErrorMessage error={errors3.inputDocumentType} /> */}
                        <ErrorMessage
                          error={
                            errors3[
                              `${vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.name}`
                            ]
                          }
                        />
                        <Controller
                          name={vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.name}
                          control={control3}
                          defaultValue={
                            vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.value
                          }
                          rules={isValidators(
                            vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.validators
                          )}
                          render={(props) => {
                            return (
                              <SelectPicker
                                searchable={false}
                                data={
                                  vendorRequestSchema?.forms?.attachFiles?.inputDocumentType
                                    ?.options || []
                                }
                                // disabled={disabledValue.fromBudgetYear}
                                value={props.value}
                                block
                                onChange={(value) => {
                                  props.onChange(value)
                                  // handleChangeBudgetYear(schema.budgetYearEndOption.name, value)
                                }}
                              />
                            )
                          }}
                        />
                      </Col>
                      <Col xs={24} sm={24} md={8} lg={8}>
                        <Button
                          block
                          // ripple
                          // appearance="ghost"
                          color="rgb(45, 168, 136)"
                          appearance="primary"
                          onClick={handleSubmit3(onSubmitVendorRequestFile)}
                          disabled={vendorRequestSchema?.forms?.attachFiles?.buttonTextDisabled}
                          style={{ marginTop: 25 }}
                        >
                          {vendorRequestSchema?.forms?.attachFiles?.buttonText}
                        </Button>
                      </Col>

                      <Col xs={24} sm={24} md={24} lg={24}>
                        <table width={'100%'} border={1} style={{ marginTop: 8 }}>
                          <thead>
                            <tr>
                              <th width="10%" style={{ textAlign: 'center' }}>
                                <p style={{ padding: 3 }}>ลำดับ</p>
                              </th>
                              <th width="45%">
                                <p style={{ padding: 3 }}>{`ไฟล์`}</p>
                              </th>
                              <th width="25%">
                                <p style={{ padding: 3 }}>ประเภทเอกสาร</p>
                              </th>
                              <th width="20%">
                                <p style={{ padding: 3 }}>#</p>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {/* {vendorRequestSchema?.forms?.attachFiles?.values?.length > 0 ? (
                              vendorRequestSchema?.forms?.attachFiles?.values?.map( */}
                            {filesImage?.length > 0 ? (
                              filesImage?.map((item, index) => {
                                return (
                                  <tr>
                                    <td align="center">{index + 1}</td>
                                    <td>
                                      <p style={{ padding: 3 }}>{item.fileName}</p>
                                    </td>
                                    <td>
                                      <p style={{ padding: 3 }}>{item.documentTypeDesc}</p>
                                    </td>
                                    <td align="center">
                                      <div style={{ padding: 3 }}>
                                        <ButtonGroup>
                                          <IconButton
                                            appearance="ghost"
                                            size="sm"
                                            icon={
                                              <Icon icon="eye" className="bt-gost-icon-radius" />
                                            }
                                            onClick={() => handlePreviewFile(item)}
                                            // disabled={!item?.path}
                                          />
                                          <IconButton
                                            appearance="ghost"
                                            size="sm"
                                            icon={
                                              <Icon
                                                icon="download"
                                                className="bt-gost-icon-none-radius"
                                              />
                                            }
                                            onClick={() => handleDownloadFile(item)}
                                            // disabled={!item?.path}
                                          />
                                          {!vendorRequestSchema?.forms?.attachFiles
                                            ?.buttonTextDisabled && (
                                            <IconButton
                                              appearance="ghost"
                                              size="sm"
                                              className="rs-btn-ghost-cancel"
                                              icon={
                                                <Icon
                                                  icon="trash"
                                                  className="bt-gost-icon-radius-cancel"
                                                />
                                              }
                                              // disabled={filesImage.length == 1}
                                              onClick={() => handleDeleteFile(item)}
                                              // disabled={!item?.path}
                                            />
                                          )}
                                        </ButtonGroup>
                                      </div>
                                    </td>
                                  </tr>
                                )
                              })
                            ) : (
                              <tr>
                                <td colSpan={4} align="center">
                                  <p style={{ padding: 3 }}>...ไม่มีข้อมูลไฟล์แนบ...</p>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </Col>
                    </Row>
                  </div>
                </Panel>
              )}
            </Panel>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {vendorRequestSchema?.forms?.buttons?.buttonSave && (
            <Button onClick={handleSubmit2(onSubmitVendorRequest)} appearance="primary">
              {vendorRequestSchema?.forms?.buttons?.buttonSave}
            </Button>
          )}

          {vendorRequestSchema?.forms?.buttons?.buttonReqEdit && (
            <Button
              // onClick={() => {
              //   handleSendRequestEditVendorRequest()
              // }}
              onClick={handleSubmit2(handleSendRequestEditVendorRequest)}
              appearance="primary"
            >
              {vendorRequestSchema?.forms?.buttons?.buttonReqEdit}
            </Button>
          )}

          {vendorRequestSchema?.forms?.buttons?.buttonCancel && (
            <Button
              onClick={() => {
                setVendorRequestShowModal(false)
              }}
              appearance="subtle"
            >
              {vendorRequestSchema?.forms?.buttons?.buttonCancel}
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <ConfirmWidget
        title={`ยืนยันการ${formSchema.buttonText}`}
        show={isShowConfirm}
        detail={`คุณต้องการส่งใบขอเบิกเงินงวดและรายงานความก้าวหน้า`}
        onCancle={onCancle}
        onConfirm={onConfirm}
        size={'sm'}
      />
    </Panel>
  ) : (
    !hidePreview && (
      <div>
        {isPdfError ? (
          <Message showIcon type="error" description={'ไม่พบไฟล์ PDF'} />
        ) : (
          <PdfRenderWidgets
            file={previewPdf}
            isLoading={isLoadingPDF}
            fileName={'แบบขอเบิกเงินโครงการ'}
            header={'แบบขอเบิกเงินโครงการ'}
            loadingMessage={`กรุณารอสักครู่ ระบบกำลัง${
              isEmpty(withdrawFile) ? 'สร้าง' : 'โหลด'
            } PDF แบบขอเบิกเงินโครงการ...`}
            onReload={() => {
              if (isEmpty(withdrawFile)) {
                handleGetDownloadWithdrawPaymentFile(requestId)
              } else {
                handleGetDownloadWithdrawPaymentFileByPath(withdrawFile)
              }
            }}
            firstExpandToReload={true}
          />
        )}
      </div>
    )
  )
}
